import { render, staticRenderFns } from "./PhysicianProfilePresenter.vue?vue&type=template&id=3aa2c538&scoped=true&"
import script from "./PhysicianProfilePresenter.vue?vue&type=script&lang=js&"
export * from "./PhysicianProfilePresenter.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianProfilePresenter.vue?vue&type=style&index=0&id=3aa2c538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa2c538",
  null
  
)

component.options.__file = "PhysicianProfilePresenter.vue"
export default component.exports